import { ProductType } from '@bcf-shared-settings/settings/enums';
import { environmentCommon } from 'configs/environments/environment.common';

const brandName: string = 'lvbetcom';
// eslint-disable-next-line @typescript-eslint/typedef
export const environmentBase = {
  baseDomainName: 'lvbet',
  ...environmentCommon,
  productType: ProductType.sportsbook,
  brandI18Name: brandName,
  brandCmsName: 'lvbetcom',
  brandName: 'Lv Bet',
  langs: ['en', 'hu', 'es', 'de', 'fi'],
  langsI18nMap: {
    en: 'en_US'
  },
  cmsHeadlessEnabled: true
};
